import { isWidgetRoute } from "schemas/miniappRoutes/widgets";

import { getHostParam } from "./host-params";

// NOTE (Gabe, 2026-09-23): BedrockProvider keeps tab activity in React state; code outside React reads this mirror.
let isTabActive = true;
const tabActiveListeners = new Set<() => void>();

// The host's `miniappRoute` is basepath-relative; `window.location.pathname`
// carries the dev `/miniapp/<id>/` prefix that would defeat `isWidgetRoute`.
export function isWidgetEmbed(): boolean {
  return isWidgetRoute(getHostParam("miniappRoute") ?? "");
}

export function setMiniappTabActive(nextIsTabActive: boolean) {
  if (nextIsTabActive === isTabActive) {
    return;
  }
  isTabActive = nextIsTabActive;
  for (const listener of tabActiveListeners) {
    listener();
  }
}

/**
 * Whether this mini-app is in front of the user: its host tab is the active one (widgets report
 * inactive forever, so a live widget counts as in front) and the browser tab is visible.
 */
export function isMiniappInFrontOfUser(): boolean {
  return (
    (isTabActive || isWidgetEmbed()) && document.visibilityState !== "hidden"
  );
}

/** Calls `listener` whenever `isMiniappInFrontOfUser()` may have changed. */
export function subscribeToMiniappInFrontOfUser(
  listener: () => void,
): () => void {
  tabActiveListeners.add(listener);
  document.addEventListener("visibilitychange", listener);
  return () => {
    tabActiveListeners.delete(listener);
    document.removeEventListener("visibilitychange", listener);
  };
}
